(() => {
  const ROOT_SELECTOR = '[data-hxcc-root]';
  const DESKTOP = window.matchMedia('(min-width: 960px)');
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const VALID_TARGETS = ['before-visit', 'consultation', 'appointment', 'cancellation', 'safety', 'policies', 'faq'];
  const OVERLAY_KEY = 'hxccOverlay';
  const FORM_KEY = 'hxccForm';
  const POLICY_KEY = 'hxccPolicy';
  const CONTACT_KEY = 'hxccContact';

  const scrollBehavior = () => REDUCED_MOTION.matches ? 'auto' : 'smooth';

  function init(root) {
    if (!root || root.dataset.hxccReady === 'true') return;

    root.dataset.hxccReady = 'true';
    root.classList.add('is-enhanced');

    const navButtons = Array.from(root.querySelectorAll('[data-hxcc-nav-target]'));
    const panels = Array.from(root.querySelectorAll('[data-hxcc-panel]'));
    const mobileNav = root.querySelector('details[data-hxcc-mobile-nav]');
    const mobileTrigger = mobileNav?.querySelector('.hxcc-explore-mobile__trigger');
    const mobileSheet = root.querySelector('[data-hxcc-mobile-sheet]');
    const mobileClose = root.querySelector('[data-hxcc-mobile-close]');
    const mobileBack = root.querySelector('[data-hxcc-mobile-back]');
    const mobileBackdrop = root.querySelector('[data-hxcc-mobile-backdrop]');
    const mobileListHeader = root.querySelector('[data-hxcc-mobile-list-header]');
    const mobileListView = root.querySelector('[data-hxcc-mobile-list-view]');
    const mobileDetailView = root.querySelector('[data-hxcc-mobile-detail-view]');
    const mobileDetailContent = root.querySelector('[data-hxcc-mobile-detail-content]');
    const mobileScroll = root.querySelector('[data-hxcc-mobile-scroll]');
    const mobilePagination = root.querySelector('[data-hxcc-mobile-pagination]');
    const formModal = root.querySelector('[data-hxcc-form-modal]');
    const formBackdrop = root.querySelector('[data-hxcc-form-backdrop]');
    const formClose = root.querySelector('[data-hxcc-form-close]');
    const formFrame = root.querySelector('[data-hxcc-form-frame]');
    const policyModal = root.querySelector('[data-hxcc-policy-modal]');
    const policyBackdrop = root.querySelector('[data-hxcc-policy-backdrop]');
    const policyClose = root.querySelector('[data-hxcc-policy-close]');
    const policyTitle = root.querySelector('[data-hxcc-policy-modal-title]');
    const policyBody = root.querySelector('[data-hxcc-policy-modal-body]');
    const policyStatus = root.querySelector('[data-hxcc-policy-status]');
    const policyContent = root.querySelector('[data-hxcc-policy-content]');
    const policyFrame = root.querySelector('[data-hxcc-policy-frame]');
    const policyDirect = root.querySelector('[data-hxcc-policy-direct]');
    const contactModal = root.querySelector('[data-hxcc-contact-modal]');
    const contactBackdrop = root.querySelector('[data-hxcc-contact-backdrop]');
    const contactClose = root.querySelector('[data-hxcc-contact-close]');
    const contactResult = root.querySelector('[data-hxcc-contact-result]');
    const frame = root.querySelector('.hxcc-frame');
    const historyRoot = root.id || 'hexie-client-care';

    let mobileDetailTarget = '';
    let lastFormTrigger = null;
    let lastPolicyTrigger = null;
    let policyRequestId = 0;
    let restoringHistory = false;

    function panelFor(target) {
      return panels.find((panel) => panel.dataset.hxccPanel === target);
    }

    function mobileButtonFor(target) {
      return navButtons.find((button) => button.dataset.hxccNavTarget === target && button.closest('[data-hxcc-mobile-nav]'));
    }

    function mobileTargets() {
      return navButtons
        .filter((button) => button.closest('[data-hxcc-mobile-nav]'))
        .map((button) => button.dataset.hxccNavTarget)
        .filter(Boolean);
    }

    function setPanel(target) {
      if (!VALID_TARGETS.includes(target)) return false;
      const selected = panelFor(target);
      if (!selected) return false;

      panels.forEach((panel) => panel.classList.toggle('is-active', panel === selected));
  
    navButtons.forEach((button) => {
        const active = button.dataset.hxccNavTarget === target;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
      });

      return true;
    }

    function pageStickyOffset() {
      const candidates = [
        document.querySelector('sticky-header'),
        document.querySelector('.shopify-section-header-sticky'),
        document.querySelector('#shopify-section-header')
      ].filter(Boolean);

      let offset = 0;

      candidates.forEach((element) => {
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const positioned = style.position === 'sticky' || style.position === 'fixed';

        if (positioned && rect.bottom > 0 && rect.top <= 4) {
          offset = Math.max(offset, rect.bottom);
        }
      });

      return Math.max(0, Math.round(offset));
    }


    function scrollPageStart() {
      const anchor = root.querySelector('.hxcc-breadcrumb') || root;

      window.requestAnimationFrame(() => {
        const top =
          window.scrollY +
          anchor.getBoundingClientRect().top -
          pageStickyOffset() -
          12;

        window.scrollTo({
          top: Math.max(0, Math.round(top)),
          behavior: scrollBehavior()
        });
      });
    }

    function panelHeadingFor(target) {
      const panel = panelFor(target);
      if (!panel) return null;

      return (
        panel.querySelector('.hxcc-panel__intro') ||
        panel.querySelector('.hxcc-panel__content h2, .hxcc-panel__content h1') ||
        panel
      );
    }

    function scrollPanel(target) {
      const anchor = panelHeadingFor(target);
      if (!anchor) return;

      window.requestAnimationFrame(() => {
        const top =
          window.scrollY +
          anchor.getBoundingClientRect().top -
          pageStickyOffset() -
          12;

        window.scrollTo({
          top: Math.max(0, Math.round(top)),
          behavior: scrollBehavior()
        });
      });
    }

    function resetMobileScroll() {
      if (!mobileScroll) return;

      mobileScroll.scrollTop = 0;

      window.requestAnimationFrame(() => {
        mobileScroll.scrollTop = 0;
      });
    }

    function overlayState(state = window.history.state) {
      const overlay = state?.[OVERLAY_KEY];
      if (!overlay || overlay.root !== historyRoot) return null;
      return overlay;
    }

    function formState(state = window.history.state) {
      const form = state?.[FORM_KEY];
      if (!form || form.root !== historyRoot) return null;
      return form;
    }

    function policyState(state = window.history.state) {
      const policy = state?.[POLICY_KEY];
      if (!policy || policy.root !== historyRoot) return null;
      return policy;
    }

    function contactState(state = window.history.state) {
      const contact = state?.[CONTACT_KEY];
      if (!contact || contact.root !== historyRoot) return null;
      return contact;
    }

    function updatePageLock() {
      const menuOpen = Boolean(mobileNav?.open && !DESKTOP.matches);
      const formOpen = Boolean(formModal && !formModal.hidden);
      const policyOpen = Boolean(policyModal && !policyModal.hidden);
      const contactOpen = Boolean(contactModal && !contactModal.hidden);
      document.documentElement.classList.toggle('hxcc-overlay-open', menuOpen || formOpen || policyOpen || contactOpen);
    }

    function pushOverlay(view, target = '') {
      window.history.pushState({
        ...(window.history.state || {}),
        [OVERLAY_KEY]: { root: historyRoot, view, target }
      }, '', window.location.href);
    }

    function updatePagination() {
      if (!mobilePagination) return;
      const targets = mobileTargets();
      const index = targets.indexOf(mobileDetailTarget);
      mobilePagination.replaceChildren();

      if (index < 0 || targets.length < 2) {
        mobilePagination.hidden = true;
        return;
      }

      targets.forEach((target, dotIndex) => {
        const dot = document.createElement('span');
        dot.className = 'hxcc-explore-mobile__dot';
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-hidden', 'true');
        mobilePagination.appendChild(dot);
      });

      mobilePagination.hidden = false;
    }

    function showMobileList(focusActive = false) {
      const previous = mobileDetailTarget;
      mobileDetailTarget = '';
      if (mobileNav) mobileNav.dataset.hxccView = 'menu';
      if (mobileListHeader) mobileListHeader.hidden = false;
      if (mobileBack) mobileBack.hidden = true;
      if (mobileListView) mobileListView.hidden = false;
      if (mobileDetailView) mobileDetailView.hidden = true;
      if (mobileDetailContent) mobileDetailContent.replaceChildren();
      resetMobileScroll();
      if (mobileClose) mobileClose.setAttribute('aria-label', 'Close Explore Client Care');
      updatePagination();

      if (focusActive) {
        const button = mobileButtonFor(previous) || root.querySelector('[data-hxcc-mobile-nav] [data-hxcc-nav-target].is-active');
        window.requestAnimationFrame(() => button?.focus());
      }
    }

    function showMobileDetail(target, focusBack = true) {
      const source = panelFor(target)?.querySelector('.hxcc-panel__content');
      if (!source || !mobileDetailContent) return false;

      const fragment = document.createDocumentFragment();
      Array.from(source.children).forEach((child) => fragment.appendChild(child.cloneNode(true)));
      mobileDetailContent.replaceChildren(fragment);
      mobileDetailTarget = target;

      if (mobileNav) mobileNav.dataset.hxccView = 'detail';
      if (mobileListHeader) mobileListHeader.hidden = true;
      if (mobileBack) mobileBack.hidden = false;
      if (mobileListView) mobileListView.hidden = true;
      if (mobileDetailView) mobileDetailView.hidden = false;
      resetMobileScroll();
      if (mobileClose) mobileClose.setAttribute('aria-label', 'Back to Explore Client Care');
      updatePagination();
      if (focusBack) window.requestAnimationFrame(() => mobileBack?.focus());
      return true;
    }

    function openMobileMenu({ push = true, focusClose = true } = {}) {
      if (!mobileNav || DESKTOP.matches) return;
      showMobileList(false);
      restoringHistory = !push;
      mobileNav.open = true;
      restoringHistory = false;
      if (push && !overlayState()) pushOverlay('menu');
      updatePageLock();
      if (focusClose) window.requestAnimationFrame(() => mobileClose?.focus());
    }

    function closeMobileDirect(restoreFocus = true) {
      if (!mobileNav) return;
      restoringHistory = true;
      mobileNav.open = false;
      showMobileList(false);
      restoringHistory = false;
      updatePageLock();
      if (restoreFocus) window.requestAnimationFrame(() => mobileTrigger?.focus());
    }

    function openMobileTarget(target, { push = true } = {}) {
      if (!setPanel(target)) return;
      scrollPageStart();
      openMobileMenu({ push, focusClose: false });
      if (!showMobileDetail(target, false)) return;

      if (push) {
        const current = overlayState();
        if (current?.view === 'menu') pushOverlay('detail', target);
        else if (!current) {
          pushOverlay('menu');
          pushOverlay('detail', target);
        }
      }

      window.requestAnimationFrame(() => mobileBack?.focus());
    }

    function focusables(container) {
      if (!container) return [];
      return Array.from(container.querySelectorAll('a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])'))
        .filter((element) => !element.hasAttribute('hidden') && element.offsetParent !== null);
    }

    function trapTab(event, container) {
      if (event.key !== 'Tab') return;
      const items = focusables(container);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function setModalIsolation(activeModal, activeBackdrop, active) {
      if (!frame) return;

      Array.from(frame.children).forEach((child) => {
        if (child === activeModal || child === activeBackdrop) return;
        if (active) child.setAttribute('inert', '');
        else child.removeAttribute('inert');
      });
    }

    function ensureFormLoaded() {
      if (!formFrame || formFrame.hasAttribute('src')) return;
      const src = formFrame.dataset.hxccFormSrc;
      if (src) formFrame.src = src;
    }

    function openForm(trigger, { push = true } = {}) {
      if (!formModal || !formBackdrop) return;
      lastFormTrigger = trigger || document.activeElement;
      ensureFormLoaded();
      formBackdrop.hidden = false;
      formModal.hidden = false;
      setModalIsolation(formModal, formBackdrop, true);
      updatePageLock();
      if (push) {
        window.history.pushState({
          ...(window.history.state || {}),
          [FORM_KEY]: { root: historyRoot }
        }, '', window.location.href);
      }
      window.requestAnimationFrame(() => formClose?.focus());
    }

    function closeFormDirect(restoreFocus = true) {
      if (!formModal || formModal.hidden) return;
      formModal.hidden = true;
      if (formBackdrop) formBackdrop.hidden = true;
      setModalIsolation(formModal, formBackdrop, false);
      updatePageLock();
      if (restoreFocus) window.requestAnimationFrame(() => lastFormTrigger?.focus?.());
    }

    function requestCloseForm() {
      if (formState() && window.history.length > 1) window.history.back();
      else closeFormDirect(true);
    }

    function policyLabel(trigger) {
      return trigger?.dataset?.hxccPolicyTitle?.trim()
        || trigger?.querySelector?.('.hxcc-policy__title')?.textContent?.trim()
        || trigger?.textContent?.trim()
        || 'Policy';
    }

    function setPolicyDirect(url, title = 'Policy') {
      if (!policyDirect) return;

      if (!url) {
        policyDirect.hidden = true;
        policyDirect.removeAttribute('href');
        policyDirect.removeAttribute('aria-label');
        return;
      }

      policyDirect.href = url;
      policyDirect.hidden = false;
      policyDirect.setAttribute('aria-label', `Open ${title} separately`);
    }

    function resetPolicyViewer() {
      policyRequestId += 1;
      if (policyStatus) {
        policyStatus.hidden = false;
        policyStatus.textContent = 'Loading policy…';
      }
      if (policyContent) {
        policyContent.hidden = true;
        policyContent.replaceChildren();
      }
      if (policyFrame) {
        policyFrame.hidden = true;
        policyFrame.removeAttribute('src');
      }
      setPolicyDirect('', 'Policy');
    }

    function cleanPolicyFragment(source, title) {
      const fragment = source.cloneNode(true);
      fragment.querySelectorAll('script, style, link, meta, noscript, iframe, form, header, footer, nav').forEach((node) => node.remove());
      fragment.querySelectorAll('.shopify-policy__title').forEach((node) => node.remove());

      const firstHeading = fragment.querySelector('h1');
      if (firstHeading) {
        const headingText = firstHeading.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        const titleText = String(title || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!titleText || headingText === titleText || source.matches('.shopify-policy__container, .shopify-policy__body')) {
          firstHeading.remove();
        }
      }

      fragment.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));

      fragment.querySelectorAll('*').forEach((node) => {
        Array.from(node.attributes).forEach((attribute) => {
          if (/^on/i.test(attribute.name)) node.removeAttribute(attribute.name);
        });
      });

      fragment.querySelectorAll('a[href]').forEach((link) => {
        const rawHref = link.getAttribute('href')?.trim() || '';
        if (/^(javascript|data):/i.test(rawHref)) {
          link.removeAttribute('href');
        }
        link.removeAttribute('target');
        link.removeAttribute('rel');
      });

      return fragment;
    }

    function sourceFromPolicyDocument(doc) {
      return doc.querySelector('.shopify-policy__container')
        || doc.querySelector('.shopify-policy__body')
        || doc.querySelector('main .rte')
        || doc.querySelector('main')
        || doc.querySelector('[role="main"]');
    }

    function showPolicyFrame(url, title) {
      if (!policyFrame) return;
      if (policyStatus) policyStatus.hidden = true;
      if (policyContent) {
        policyContent.hidden = true;
        policyContent.replaceChildren();
      }
      policyFrame.title = `HEXIE Beauty ${title}`;
      policyFrame.src = url;
      policyFrame.hidden = false;
    }

    async function loadPolicy(url, title) {
      const requestId = ++policyRequestId;
      if (policyTitle) policyTitle.textContent = title || 'Policy';
      if (policyStatus) {
        policyStatus.hidden = false;
        policyStatus.textContent = 'Loading policy…';
      }
      if (policyContent) {
        policyContent.hidden = true;
        policyContent.replaceChildren();
      }
      if (policyFrame) {
        policyFrame.hidden = true;
        policyFrame.removeAttribute('src');
      }
      if (policyBody) policyBody.scrollTop = 0;

      let resolved;
      try {
        resolved = new URL(url, window.location.href);
        setPolicyDirect(resolved.href, title || 'Policy');
      } catch {
        if (policyStatus) policyStatus.textContent = 'This policy could not be loaded.';
        return;
      }

      if (resolved.origin !== window.location.origin) {
        showPolicyFrame(resolved.href, title);
        return;
      }

      try {
        const response = await fetch(resolved.href, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Policy request failed');

        const html = await response.text();
        if (requestId !== policyRequestId) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = sourceFromPolicyDocument(doc);
        if (!source) throw new Error('Policy content not found');

        const fragment = cleanPolicyFragment(source, title);
        if (!policyContent) return;
        policyContent.replaceChildren(...Array.from(fragment.childNodes));
        policyContent.hidden = false;
        if (policyStatus) policyStatus.hidden = true;
      } catch {
        if (requestId !== policyRequestId) return;
        showPolicyFrame(resolved.href, title);
      }
    }

    function openPolicy(trigger, { push = true } = {}) {
      if (!policyModal || !policyBackdrop || !trigger) return;
      const href = trigger.getAttribute('href');
      if (!href) return;

      lastPolicyTrigger = trigger;
      resetPolicyViewer();
      policyBackdrop.hidden = false;
      policyModal.hidden = false;
      setModalIsolation(policyModal, policyBackdrop, true);
      updatePageLock();

      if (push) {
        window.history.pushState({
          ...(window.history.state || {}),
          [POLICY_KEY]: { root: historyRoot }
        }, '', window.location.href);
      }

      loadPolicy(href, policyLabel(trigger));
      window.requestAnimationFrame(() => policyClose?.focus());
    }

    function closePolicyDirect(restoreFocus = true) {
      if (!policyModal || policyModal.hidden) return;
      policyRequestId += 1;
      policyModal.hidden = true;
      if (policyBackdrop) policyBackdrop.hidden = true;
      setModalIsolation(policyModal, policyBackdrop, false);
      if (policyFrame) {
        policyFrame.hidden = true;
        policyFrame.removeAttribute('src');
      }
      if (policyContent) {
        policyContent.hidden = true;
        policyContent.replaceChildren();
      }
      if (policyStatus) {
        policyStatus.hidden = false;
        policyStatus.textContent = '';
      }
      setPolicyDirect('', 'Policy');
      updatePageLock();
      if (restoreFocus) window.requestAnimationFrame(() => lastPolicyTrigger?.focus?.());
    }

    function requestClosePolicy() {
      if (policyState() && window.history.length > 1) window.history.back();
      else closePolicyDirect(true);
    }

    function openContact(trigger, { push = true } = {}) {
      if (!contactModal || !contactBackdrop) return;
      contactBackdrop.hidden = false;
      contactModal.hidden = false;
      setModalIsolation(contactModal, contactBackdrop, true);
      updatePageLock();

      if (push) {
        window.history.pushState({
          ...(window.history.state || {}),
          [CONTACT_KEY]: { root: historyRoot }
        }, '', window.location.href);
      }

      window.requestAnimationFrame(() => {
        if (contactResult) contactResult.focus();
        else contactClose?.focus();
      });
    }

    function closeContactDirect(restoreFocus = true) {
      if (!contactModal || contactModal.hidden) return;
      contactModal.hidden = true;
      if (contactBackdrop) contactBackdrop.hidden = true;
      setModalIsolation(contactModal, contactBackdrop, false);
      updatePageLock();

      if (restoreFocus) {
        window.requestAnimationFrame(() => {
          const activeTrigger = root.querySelector('[data-hxcc-open-contact][data-hxcc-last-contact-trigger="true"]');
          activeTrigger?.focus?.();
          activeTrigger?.removeAttribute('data-hxcc-last-contact-trigger');
        });
      }
    }

    function requestCloseContact() {
      if (contactState() && window.history.length > 1) window.history.back();
      else closeContactDirect(true);
    }

    function adjacentDetail(direction) {
      const targets = mobileTargets();
      const index = targets.indexOf(mobileDetailTarget);
      if (index < 0) return;
      const next = index + direction;
      if (next < 0 || next >= targets.length) return;
      const target = targets[next];
      if (!setPanel(target) || !showMobileDetail(target, false)) return;

      const state = window.history.state || {};
      window.history.replaceState({
        ...state,
        [OVERLAY_KEY]: { root: historyRoot, view: 'detail', target }
      }, '', window.location.href);
    }

    function bindSwipe(element, { onRight, onLeft } = {}) {
      if (!element) return;

      element.style.touchAction = 'pan-y';
      element.style.overscrollBehaviorX = 'contain';

      let tracking = false;
      let horizontalIntent = false;
      let handled = false;
      let startX = 0;
      let startY = 0;
      let lastX = 0;
      let lastY = 0;

      function resetGesture() {
        tracking = false;
        horizontalIntent = false;
        handled = false;
        startX = 0;
        startY = 0;
        lastX = 0;
        lastY = 0;
      }

      function beginGesture(x, y) {
        tracking = true;
        horizontalIntent = false;
        handled = false;
        startX = x;
        startY = y;
        lastX = x;
        lastY = y;
      }

      function performGesture(deltaX) {
        if (handled) return false;

        if (deltaX > 0 && typeof onRight === 'function') {
          handled = true;
          onRight();
          return true;
        }

        if (deltaX < 0 && typeof onLeft === 'function') {
          handled = true;
          onLeft();
          return true;
        }

        return false;
      }

      function updateGesture(x, y, event) {
        if (!tracking || handled) return;

        lastX = x;
        lastY = y;

        const deltaX = lastX - startX;
        const deltaY = lastY - startY;
        const horizontal = Math.abs(deltaX);
        const vertical = Math.abs(deltaY);

        if (!horizontalIntent && horizontal >= 10 && horizontal > vertical * 1.08) {
          horizontalIntent = true;
        }

        if (!horizontalIntent) return;

        if (event?.cancelable) event.preventDefault();

        if (horizontal >= 42 && horizontal > vertical * 1.12) {
          performGesture(deltaX);
        }
      }

      function finishGesture(x, y, event) {
        if (!tracking) return;

        lastX = x;
        lastY = y;

        const deltaX = lastX - startX;
        const deltaY = lastY - startY;
        const horizontal = Math.abs(deltaX);
        const vertical = Math.abs(deltaY);

        if (!handled && horizontal >= 30 && horizontal > vertical * 1.1) {
          if (event?.cancelable) event.preventDefault();
          performGesture(deltaX);
        }

        window.setTimeout(resetGesture, 0);
      }

      element.addEventListener(
        'touchstart',
        (event) => {
          if (DESKTOP.matches || event.touches.length !== 1) return;
          const touch = event.touches[0];
          beginGesture(touch.clientX, touch.clientY);
        },
        { passive: true, capture: true }
      );

      element.addEventListener(
        'touchmove',
        (event) => {
          if (!tracking || DESKTOP.matches || event.touches.length !== 1) return;
          const touch = event.touches[0];
          updateGesture(touch.clientX, touch.clientY, event);
        },
        { passive: false, capture: true }
      );

      element.addEventListener(
        'touchend',
        (event) => {
          if (!tracking || DESKTOP.matches || event.changedTouches.length !== 1) return;
          const touch = event.changedTouches[0];
          finishGesture(touch.clientX, touch.clientY, event);
        },
        { passive: false, capture: true }
      );

      element.addEventListener(
        'touchcancel',
        () => resetGesture(),
        { capture: true }
      );
    }

    navButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = button.dataset.hxccNavTarget;
        if (!VALID_TARGETS.includes(target)) return;

        if (button.closest('[data-hxcc-mobile-nav]')) {
          event.preventDefault();
          openMobileTarget(target, { push: true });
          return;
        }

        if (setPanel(target)) {
          window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}#${target}`);
        }
      });
    });

    root.addEventListener('click', (event) => {
      const faqSummary = event.target.closest('.hxcc-faq__summary');
      if (faqSummary && root.contains(faqSummary)) {
        const current = faqSummary.closest('details[data-hxcc-faq-item]');
        const group = current?.closest('[data-hxcc-faq-group]');

        if (current && group) {
          window.requestAnimationFrame(() => {
            if (!current.open) return;
            group.querySelectorAll('details[data-hxcc-faq-item][open]').forEach((item) => {
              if (item !== current) item.removeAttribute('open');
            });
          });
        }
      }

      const contactTrigger = event.target.closest('[data-hxcc-open-contact]');
      if (contactTrigger && root.contains(contactTrigger)) {
        event.preventDefault();
        root.querySelectorAll('[data-hxcc-last-contact-trigger="true"]').forEach((element) => element.removeAttribute('data-hxcc-last-contact-trigger'));
        contactTrigger.setAttribute('data-hxcc-last-contact-trigger', 'true');
        openContact(contactTrigger, { push: true });
        return;
      }

      const chatTrigger = event.target.closest('[data-hxcc-use-chat]');
      if (chatTrigger && root.contains(chatTrigger)) {
        event.preventDefault();
        requestCloseContact();
        return;
      }

      const policyTrigger = event.target.closest('[data-hxcc-open-policy]');
      if (policyTrigger && root.contains(policyTrigger)) {
        event.preventDefault();
        openPolicy(policyTrigger, { push: true });
        return;
      }

      const trigger = event.target.closest('[data-hxcc-open-form]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      openForm(trigger, { push: true });
    });

    mobileNav?.addEventListener('toggle', () => {
      const open = mobileNav.open && !DESKTOP.matches;
      if (mobileBackdrop) mobileBackdrop.hidden = !open;
      if (open && !restoringHistory && !overlayState()) pushOverlay('menu');
      updatePageLock();
    });

    mobileTrigger?.addEventListener('click', (event) => {
      if (DESKTOP.matches) return;
      event.preventDefault();
      if (mobileNav?.open) {
        if (overlayState() && window.history.length > 1) window.history.back();
        else closeMobileDirect(true);
      } else {
        openMobileMenu({ push: true, focusClose: true });
      }
    });

    mobileBack?.addEventListener('click', () => {
      const state = overlayState();
      if (state?.view === 'detail' && window.history.length > 1) window.history.back();
      else showMobileList(true);
    });

    mobileClose?.addEventListener('click', () => {
      const state = overlayState();
      if (state?.view === 'detail' && window.history.length > 1) window.history.back();
      else if (state?.view === 'menu' && window.history.length > 1) window.history.back();
      else if (mobileDetailTarget) showMobileList(true);
      else closeMobileDirect(true);
    });

    mobileBackdrop?.addEventListener('click', () => {
      const state = overlayState();
      if (state?.view === 'detail' && window.history.length > 2) window.history.go(-2);
      else if (state && window.history.length > 1) window.history.back();
      else closeMobileDirect(true);
    });

    formClose?.addEventListener('click', requestCloseForm);
    formBackdrop?.addEventListener('click', requestCloseForm);
    policyClose?.addEventListener('click', requestClosePolicy);
    policyBackdrop?.addEventListener('click', requestClosePolicy);
    contactClose?.addEventListener('click', requestCloseContact);
    contactBackdrop?.addEventListener('click', requestCloseContact);

    policyBody?.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || !policyBody.contains(link)) return;

      let url;
      try {
        url = new URL(link.getAttribute('href'), window.location.href);
      } catch {
        return;
      }

      const isPolicyDestination = url.origin === window.location.origin
        && (url.pathname.startsWith('/policies/') || url.pathname.includes('policy'));

      if (!isPolicyDestination) return;

      event.preventDefault();
      const nextTitle = link.textContent.trim() || policyTitle?.textContent || 'Policy';
      loadPolicy(url.href, nextTitle);
    });

    mobileSheet?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        if (mobileDetailTarget) {
          const state = overlayState();
          if (state?.view === 'detail' && window.history.length > 1) window.history.back();
          else showMobileList(true);
        } else {
          const state = overlayState();
          if (state && window.history.length > 1) window.history.back();
          else closeMobileDirect(true);
        }
        return;
      }
      trapTab(event, mobileSheet);
    });

    formModal?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        requestCloseForm();
        return;
      }
      trapTab(event, formModal);
    });

    policyModal?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        requestClosePolicy();
        return;
      }
      trapTab(event, policyModal);
    });

    contactModal?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        requestCloseContact();
        return;
      }
      trapTab(event, contactModal);
    });

    bindSwipe(mobileDetailView, {
      onLeft: () => {
        if (!mobileNav?.open || !mobileDetailTarget) return;
        adjacentDetail(1);
      },
      onRight: () => {
        if (!mobileNav?.open || !mobileDetailTarget) return;
        adjacentDetail(-1);
      }
    });

    const mobileMenuButtons = navButtons.filter((button) =>
      Boolean(button.closest('[data-hxcc-mobile-nav]'))
    );

    mobileMenuButtons.forEach((button) => {
      bindSwipe(button, {
        onLeft: () => {
          if (!mobileNav?.open || DESKTOP.matches) return;
          if (mobileDetailTarget) return;

          const target = button.dataset.hxccNavTarget;
          if (!VALID_TARGETS.includes(target)) return;

          if (setPanel(target) && showMobileDetail(target, false)) {
            const current = overlayState();

            if (current?.view === 'menu') {
              pushOverlay('detail', target);
            } else if (!current) {
              pushOverlay('menu');
              pushOverlay('detail', target);
            }
          }

          window.requestAnimationFrame(() => mobileBack?.focus());
        }
      });
    });

    if (mobileTrigger) {
      let startX = 0;
      let startY = 0;
      mobileTrigger.addEventListener('touchstart', (event) => {
        if (DESKTOP.matches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      mobileTrigger.addEventListener('touchend', (event) => {
        if (DESKTOP.matches || event.changedTouches.length !== 1 || mobileNav?.open) return;
        const deltaX = event.changedTouches[0].clientX - startX;
        const deltaY = event.changedTouches[0].clientY - startY;
        if (deltaX < -30 && Math.abs(deltaX) > Math.abs(deltaY) * 1.08) openMobileMenu({ push: true, focusClose: false });
      }, { passive: true });
    }

    window.addEventListener('popstate', (event) => {
      if (!formState(event.state)) closeFormDirect(true);
      if (!policyState(event.state)) closePolicyDirect(true);
      if (!contactState(event.state)) closeContactDirect(true);

      const overlay = overlayState(event.state);
      restoringHistory = true;
      if (overlay?.view === 'menu' && !DESKTOP.matches) {
        if (mobileNav) mobileNav.open = true;
        showMobileList(false);
      } else if (overlay?.view === 'detail' && overlay.target && !DESKTOP.matches) {
        if (mobileNav) mobileNav.open = true;
        setPanel(overlay.target);
        showMobileDetail(overlay.target, false);
      } else if (!overlay) {
        closeMobileDirect(true);
      }
      restoringHistory = false;
      updatePageLock();
    });

    DESKTOP.addEventListener?.('change', () => {
      if (DESKTOP.matches) closeMobileDirect(false);
      updatePageLock();
    });

    if (contactResult) {
      window.setTimeout(() => openContact(contactResult, { push: false }), 0);
    }

    const initialTarget = window.location.hash.replace('#', '');
    if (VALID_TARGETS.includes(initialTarget)) {
      setPanel(initialTarget);
      if (DESKTOP.matches) {
        window.setTimeout(() => scrollPanel(initialTarget), 0);
      } else {
        window.setTimeout(() => openMobileTarget(initialTarget, { push: false }), 0);
      }
    } else {
      setPanel('before-visit');
    }
  }

  function start() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
